import classNames from 'classnames';
import PropTypes from 'prop-types';

import { generateQeId, Loadable, Spinner, Icon, Tag } from '@ctct/ui-react';

import InfoRow from './InfoRow';
import './_orderSummary.scss';
import { getPlanName } from '../../utils/orderSummaryUtils';
import { formatCurrency } from '../../utils/pricingUtils';

const OrderSummary = (props) => {
  const {
    t,
    className,
    'data-qe-id': qeId,
    loading,
    currency,
    smsTierLabel,
    discountAmount,
    validatingCode,
    // discountError,
    appliedDiscountCode,
    discountCode,
    // setDiscountCode,
    applyDiscountCode,
    promoEnabled,
    rating,
  } = props;

  /*
  from Darcy:
  The Estimated Next Invoice should be monthlyPrice + monthlyTaxPrice + (for each addOnRating) monthlyCost + monthlyTax
  Today’s sub-total should be totalPrice
  Tax should be totalTaxPrice
  Today’s total should be amountToCharge
  Note that if they have money on account (a balance) the amountToCharge will be less than the totalPrice+totalTaxPrice
  */

  const { monthlyPrice, monthlyTaxPrice, totalPrice, totalTaxPrice, addOnRating, amountToCharge, ratePlans } =
    rating || {};
  const [{ monthlyCost: addOnMonthlyCost, monthlyTax: addOnMonthlyTax }] = addOnRating || [{}];

  const formatMoney = (amount) => (amount == null || Number.isNaN(amount) ? '' : formatCurrency(currency, amount));
  const estimatedNextInvoice = monthlyPrice + monthlyTaxPrice + addOnMonthlyCost + addOnMonthlyTax;
  const todaySubTotal = totalPrice;
  const tax = totalTaxPrice;
  const todaysTotal = amountToCharge;
  const classes = classNames('utils-order-summary ctct-theme', className);
  const [ratePlan] = ratePlans || [{}];
  let planDescription = '';

  if (ratePlan && ratePlan.planTypeItem && ratePlan.planTypeItem.description) {
    const {
      planTypeItem: { description },
    } = ratePlan;

    planDescription = description;
  }

  // const discountInputClasses = () =>
  //   classNames('discount-input', discountError ? 'is-invalid' : '', loading ? 'validating' : '', className);
  const discountRowClasses = () =>
    classNames(
      'order-summary-section-row',
      'order-summary-discount-row',
      appliedDiscountCode ? '' : 'discount-hide',
      className
    );
  // const discountErrorClasses = () => classNames('error-msg', discountError ? '' : 'discount-hide', className);

  return (
    <div className={classes} data-qe-id={qeId} style={{ minWidth: 330 }}>
      <Loadable loading={loading} data-qe-id="paymentplan-discounts-order-summary-loading">
        <div className="order-summary-header-container" data-qe-id={generateQeId(qeId, 'header-container')}>
          <h3 className="order-summary-header" data-qe-id={generateQeId(qeId, 'header')}>
            {t('order_summary.header')}
          </h3>
        </div>
        <div className="order-summary-section-container" data-qe-id={generateQeId(qeId, 'contacts-plan')}>
          <InfoRow
            data-qe-id={generateQeId(qeId, 'plan-name')}
            label={t('order_summary.label.current_plan')}
            value={getPlanName({ planName: planDescription, header: true, onlyText: true })}
            classBase="plan"
          />
          <InfoRow
            data-qe-id={generateQeId(qeId, 'next-invoice')}
            label={t('order_summary.label.estimated_next_invoice')}
            value={formatMoney(estimatedNextInvoice)}
            classBase="invoice"
          />
          <div className={discountRowClasses()}>
            <span
              className={classNames('order-summary-discount-label', 'order-summary-body-left')}
              data-qe-id={generateQeId(qeId, 'discount-code')}
            >
              <Icon
                data-qe-id={generateQeId(qeId, 'clear-discount-code')}
                className="close-discount"
                onClick={() => applyDiscountCode()}
                glyph="closeCircle"
              />
              {t('order_summary.label.discount')}: {discountCode}
            </span>
            <span
              className={classNames('order-summary-discount-value', 'order-summary-body-right')}
              data-qe-id={generateQeId(qeId, 'discount-value')}
            >
              {validatingCode ? <Spinner size="small" /> : <span>-{formatMoney(discountAmount)}</span>}{' '}
            </span>
          </div>
          {/*
          <div className="order-summary-section-row">
            <div className="sidebar-accordion-panel">
              <div className="sidebar-accordion-panel-header">
                <InfoRow
                  className="sidebar-accordion-panel-action-container"
                  label={t('order_summary.discount-label')}
                  data-qe-id={generateQeId(qeId, 'discount-section-label')}
                />
              </div>
              <div className="sidebar-accordion-panel-inner" data-qe-id={generateQeId(qeId, 'discount-section')}>
                {!appliedDiscountCode ? (
                  <div className="sidebar-accordion-panel-content" data-qe-id={generateQeId(qeId, 'accordion-content')}>
                    <Input
                      invalid={!!discountError}
                      data-qe-id={generateQeId(qeId, 'discount-input')}
                      className={discountInputClasses()}
                      value={discountCode}
                      placeholder={t('order_summary.discount-input-placeholder')}
                      onChange={event => setDiscountCode(event.target.value)}
                    />
                    <Button
                      className="discount-submit-button"
                      data-qe-id={generateQeId(qeId, 'discount-apply-button')}
                      onClick={() => applyDiscountCode(discountCode)}
                      disabled={validatingCode || !discountCode}
                      busy={validatingCode}
                      text={t('order_summary.apply-button')}
                    />
                    <span className={discountErrorClasses()}>{discountError}</span>
                  </div>
                ) : (
                  <div className="sidebar-accordion-panel-content" data-qe-id={generateQeId(qeId, 'accordion-content')}>
                    <span data-qe-id={generateQeId(qeId, 'only-one-promo-text')}>
                      {t('order_summary.discount-dropdown-multiple')}
                    </span>
                  </div>
                )}
              </div>
              <div className="sidebar-accordion-panel-footer">
                <InfoRow
                  className="sidebar-accordion-panel-action-container"
                  label={t('order_summary.discount-note')}
                  data-qe-id={generateQeId(qeId, 'discount-section-note')}
                />
              </div>
            </div>
          </div>
                */}
        </div>
        <div className="order-summary-section-container" data-qe-id={generateQeId(qeId, 'sms-plan')}>
          <InfoRow
            data-qe-id={generateQeId(qeId, 'sms-addon')}
            label={t('order_summary.add-on')}
            value="SMS"
            classBase="sms"
          />
          <InfoRow
            data-qe-id={generateQeId(qeId, 'sms-messages')}
            label={t('order_summary.sms-messages')}
            value={smsTierLabel}
            classBase="sms"
          />
        </div>
        <div className="order-summary-section-container" data-qe-id={generateQeId(qeId, 'total')}>
          <InfoRow
            data-qe-id={generateQeId(qeId, 'sub-total')}
            label={
              <>
                <span>{t('order_summary.todays-subtotal')}</span>
                {promoEnabled && (
                  <span style={{ marginLeft: 7 }}>
                    <Tag
                      kind="success"
                      text={t('order_summary.discounted_price')}
                      data-qe-id={generateQeId(qeId, 'discounted-price')}
                    />
                  </span>
                )}
              </>
            }
            value={formatMoney(todaySubTotal)}
            classBase="sub-total"
          />
          <InfoRow
            data-qe-id={generateQeId(qeId, 'tax')}
            label={t('order_summary.tax')}
            value={formatMoney(tax)}
            classBase="tax"
          />
        </div>
        <div className="order-summary-section-container" data-qe-id={generateQeId(qeId, 'section-container')}>
          <div className={classNames('order-summary-section-row', 'order-summary-total-row')}>
            <span
              className={classNames('order-summary-total-label', 'order-summary-body-left')}
              data-qe-id={generateQeId(qeId, 'total')}
            >
              {t('order_summary.todays-total')}
            </span>
            <span
              className={classNames('order-summary-total-value', 'order-summary-body-right')}
              data-qe-id={generateQeId(qeId, 'total-value')}
            >
              {formatMoney(todaysTotal)}
            </span>
          </div>
        </div>
      </Loadable>
    </div>
  );
};

OrderSummary.propTypes = {
  t: PropTypes.func.isRequired,
  'data-qe-id': PropTypes.string.isRequired,
  className: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  promoEnabled: PropTypes.bool,
  currency: PropTypes.string,
  smsTierLabel: PropTypes.string,
  discountAmount: PropTypes.number,
  validatingCode: PropTypes.bool.isRequired,
  // discountError: PropTypes.string,
  discountCode: PropTypes.string,
  appliedDiscountCode: PropTypes.string,
  // setDiscountCode: PropTypes.func.isRequired,
  applyDiscountCode: PropTypes.func.isRequired,
  rating: PropTypes.shape({
    subTotal: PropTypes.number,
    monthlyPrice: PropTypes.number,
    totalTaxPrice: PropTypes.number,
    totalPrice: PropTypes.number,
  }),
};

OrderSummary.defaultProps = {
  className: '',
  rating: null,
  currency: 'USD',
  smsTierLabel: '',
  discountAmount: 0,
  // discountError: '',
  discountCode: '',
  promoEnabled: false,
  appliedDiscountCode: '',
};

export default OrderSummary;
